import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GodModeService {
  private godModeSubject = new BehaviorSubject<boolean>(this.getGodModeFromStorage());
  public godMode$: Observable<boolean> = this.godModeSubject.asObservable();

  constructor() {}

  private getGodModeFromStorage(): boolean {
    const godModeState = sessionStorage.getItem('godmode');
    return godModeState ? JSON.parse(godModeState) : false;
  }

  public getGodMode(): boolean {
    return this.godModeSubject.value;
  }

  public setGodMode(godMode: boolean): void {
    sessionStorage.setItem('godmode', JSON.stringify(godMode));
    this.godModeSubject.next(godMode);
  }

  public toggleGodMode(): boolean {
    const newGodMode = !this.getGodMode();
    this.setGodMode(newGodMode);
    return newGodMode;
  }
}
